/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_nav_user_verify_identity = /** @type {(inputs: {}) => string} */ () => {
	return `Verificar Identidad`
};

const en_nav_user_verify_identity = /** @type {(inputs: {}) => string} */ () => {
	return `Verify Identity`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const nav_user_verify_identity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_user_verify_identity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nav_user_verify_identity", locale)
	if (locale === "es") return es_nav_user_verify_identity(inputs)
	return en_nav_user_verify_identity(inputs)
};
export { nav_user_verify_identity as "nav_user.verify_identity" }